import { Component, ChangeDetectionStrategy, ChangeDetectorRef, Input } from '@angular/core';
import { trigger, style, transition, animate } from '@angular/animations';

@Component({
    selector: 'app-control-error',
    templateUrl: './control-error.component.html',
    styleUrls: ['./control-error.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    animations: [
        trigger('matErrorAnimation', [
            transition('* => *', [
                style({ opacity: 0, transform: 'translateY(-1em)' }),
                animate('0.2s ease-in', style({ opacity: 1, transform: 'translateY(0)' }))
            ])
        ])
    ]
})
export class ControlErrorComponent {
    public forbiddenName: string = '';

    @Input() public set text(value: string) {
        if (value !== this.forbiddenName) {
            this.forbiddenName = value;
            this.changeDetectorRef.detectChanges();
        }
    }

    public constructor(private changeDetectorRef: ChangeDetectorRef) {}
}
